"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fetcher = void 0;
var querystring_1 = __importDefault(require("querystring"));
var moment_1 = __importDefault(require("moment"));
var Fetcher = /** @class */ (function () {
    function Fetcher(on401) {
        this.on401 = on401;
        this.defaultHeaders = new Headers({
            accept: 'application/json',
        });
        this.defaultHeaders.append('X-TimezoneOffsetMins', moment_1.default().utcOffset().toString());
    }
    Fetcher.prototype.updatePath = function (path) {
        return path;
    };
    Fetcher.prototype.download = function (method, path, urlParameters) {
        path = this.updatePath(path);
        if (urlParameters) {
            path = path + '?' + querystring_1.default.stringify(urlParameters);
        }
        // @ts-ignore
        window.location = path;
    };
    Fetcher.prototype.postFormData = function (path, body) {
        return __awaiter(this, void 0, void 0, function () {
            var fd, i, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.updatePath(path);
                        fd = new FormData();
                        for (i in body) {
                            fd.append(i, body[i]);
                        }
                        return [4 /*yield*/, fetch(path, {
                                method: 'POST',
                                headers: this.defaultHeaders,
                                credentials: 'include',
                                cache: 'no-cache',
                                body: fd,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, this.handleResponse(result, function () { return _this.postFormData(path, body); })];
                }
            });
        });
    };
    Fetcher.prototype.postForAuth = function (path, body) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.updatePath(path);
                        return [4 /*yield*/, fetch(path, {
                                method: 'POST',
                                headers: this.defaultHeaders,
                                credentials: 'include',
                                cache: 'no-cache',
                                body: JSON.stringify(body),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, this.handleResponse(result)];
                }
            });
        });
    };
    Fetcher.prototype.post = function (path, body) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.updatePath(path);
                        return [4 /*yield*/, fetch(path, {
                                method: 'POST',
                                headers: this.defaultHeaders,
                                credentials: 'include',
                                cache: 'no-cache',
                                body: JSON.stringify(body),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, this.handleResponse(result, function () { return _this.post(path, body); })];
                }
            });
        });
    };
    Fetcher.prototype.put = function (path, body) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.updatePath(path);
                        return [4 /*yield*/, fetch(path, {
                                method: 'PUT',
                                headers: this.defaultHeaders,
                                credentials: 'include',
                                cache: 'no-cache',
                                body: JSON.stringify(body),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, this.handleResponse(result, function () { return _this.put(path, body); })];
                }
            });
        });
    };
    Fetcher.prototype.get = function (path, urlParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.updatePath(path);
                        if (urlParameters) {
                            path = path + '?' + querystring_1.default.stringify(urlParameters);
                        }
                        return [4 /*yield*/, fetch(path, {
                                method: 'GET',
                                headers: this.defaultHeaders,
                                credentials: 'include',
                                cache: 'no-cache',
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, this.handleResponse(result, function () { return _this.get(path, urlParameters); })];
                }
            });
        });
    };
    Fetcher.prototype.handleResponse = function (result, retry) {
        return __awaiter(this, void 0, void 0, function () {
            var contentType, jsonData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        contentType = result.headers.get('Content-Type');
                        if (contentType && contentType.indexOf('json') === -1) {
                            if (result.status === 404) {
                                throw new Error('Not found');
                            }
                        }
                        return [4 /*yield*/, result.json()];
                    case 1:
                        jsonData = _a.sent();
                        if (result.status === 401 && retry) {
                            return [2 /*return*/, this.on401(retry)];
                        }
                        if (jsonData && typeof jsonData === 'object' && 'error' in jsonData) {
                            throw new Error(jsonData.error);
                        }
                        if (!result.ok) {
                            throw new Error(jsonData);
                        }
                        return [2 /*return*/, jsonData];
                }
            });
        });
    };
    return Fetcher;
}());
exports.Fetcher = Fetcher;
